<div class="card b">
  <div class="card-header">
    <h4 class="">{{ "routes.dashboard.tiles.MESSAGECENTER" | translate }}</h4>
    <p style="border-bottom: 1px solid #cecece"></p>
  </div>
  <div class="card-body">
    <div *ngFor="let message of messages; let i = index" class="message-item">
      <div class="message-header">
        <div class="message-symbol" *ngIf="message.symbol">
          <ion-icon
            [name]="message.symbol"
            [style.color]="message.color"
            class="message-icon"
          ></ion-icon>
        </div>
        <div class="message-headline">
          <h4>{{ message.headline }}</h4>
        </div>
        <div class="message-date">
          {{ message.publishDate | customDate }}
        </div>
      </div>
      <div class="message-content ck-content">
        <p class="line-clamp-text">
          {{ message.text | slice: 0 : 250
          }}<span *ngIf="message.text.length > 250">... </span>
        </p>
        <button
          *ngIf="message.text.length > 250"
          (click)="showMessageModal(message)"
          class="see-more-btn"
        >
          {{ "routes.dashboard.messages.READMORE" | translate }}
        </button>
      </div>
    </div>
    <div class="bottom-spacer"></div>
  </div>
  <ng-template #noUpdates>
    <p>{{ "routes.dashboard.messages.NOUPDATES" | translate }}</p>
  </ng-template>
</div>
